module.exports = __webpack_public_path__ + "img/397.b63fe516.png";